// extracted by mini-css-extract-plugin
export default {"navigator":"index_navigator__SYa9K"};